const primary = '#FF152A'
const navy = '#201030'
const charcoal = '#2A2A2A'
const muted = '#6B7280'
const bgApp = '#F4F6F8'
const surface = '#FFFFFF'
const borderSoft = '#E5E7EB'
const bgPrimaryLight = 'rgba(32, 16, 48, .45)'
const primaryGradient = `linear-gradient(135deg, ${primary}, #C41022)`
const boxShadow = '0 8px 30px rgba(0, 0, 0, .06)'
const shadowSoft = '0 8px 30px rgba(0, 0, 0, .06)'
const radiusLg = '20px'
const radiusMd = '12px'
const radiusPill = '999px'
const widthFull = '280px'
const widthResize = '72px'
const widthWithPadding = '240px'
const widthResizeWithPadding = '48px'
const heightHeader = '64px'
const heightFooter = '32px'

export {
  boxShadow,
  shadowSoft,
  primary,
  navy,
  charcoal,
  muted,
  bgApp,
  surface,
  borderSoft,
  bgPrimaryLight,
  primaryGradient,
  radiusLg,
  radiusMd,
  radiusPill,
  widthFull,
  widthResize,
  heightHeader,
  heightFooter,
  widthWithPadding,
  widthResizeWithPadding
}
